function cov_1689q0jjz1() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sink.tsx";
  var hash = "fe762a177021db570adc8fe15acd21a12beb839d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sink.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fe762a177021db570adc8fe15acd21a12beb839d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1689q0jjz1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1689q0jjz1();
var Icon = (cov_1689q0jjz1().s[0]++, {
  name: 'sink',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.25 1.75C8.317 1.75 6.75 3.317 6.75 5.25V6.75H9.25V5.25C9.25 4.69772 9.69772 4.25 10.25 4.25C10.8023 4.25 11.25 4.69772 11.25 5.25V11.75H9.25V10C9.25 9.30964 8.69036 8.75 8 8.75C7.30964 8.75 6.75 9.30964 6.75 10V11.75H3C2.30964 11.75 1.75 12.3096 1.75 13C1.75 13.6904 2.30964 14.25 3 14.25H4.00383C4.0064 14.3337 4.01025 14.417 4.01537 14.5C4.27347 18.6854 7.74965 22 12 22C16.2504 22 19.7265 18.6854 19.9846 14.5C19.9897 14.417 19.9936 14.3337 19.9962 14.25H21C21.6904 14.25 22.25 13.6904 22.25 13C22.25 12.3096 21.6904 11.75 21 11.75H18.25V10C18.25 9.30964 17.6904 8.75 17 8.75C16.3096 8.75 15.75 9.30964 15.75 10V11.75H13.75V5.25C13.75 3.317 12.183 1.75 10.25 1.75ZM6.52242 14.5C6.77504 17.3032 9.13098 19.5 12 19.5C14.869 19.5 17.225 17.3032 17.4776 14.5H6.52242Z\" fill=\"currentColor\"/>"
});
export default Icon;